import * as React from "react";
import { connect } from "react-redux";
import * as Actions from "../../../redux/actions";
import { AppState } from "../../../redux";
import { RadivisionInterviewsShowId } from "../../../constants/content-ids";
import { useOnScreen } from "../../../utilities/use-on-screen";
import { HomeGenericJson } from "../../../component-configuration/home-generic-json";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { FixedList } from "@radivision/graphql/lib/ts/graphql/fixed-list";
import { DynamicList } from "@radivision/graphql/lib/ts/graphql/dynamic-list";
import { FetchListPayload, FetchListAction } from "../../../redux/cache/types";
import { Router } from "../../../utilities/router";
import { getPTDate } from "../../../utilities/get-pt-date";
import { rotate } from "../../../utilities/rotate";
import { PseudoRandom } from "../../../utilities/pseudo-random";
import { randomize } from "../../../utilities/randomize";
import { getPreviews } from "./selectors";
import { ItemPreviews } from "./types";
import { MiniHeroPanel } from "./panel";

interface MapDispatchProps {
  fetchList: (payload: FetchListPayload) => FetchListAction;
}

interface ComponentProps {
  fixedList?: { id: string };
  forceNumberOfItems?: number;
  json: HomeGenericJson;
  list?: FixedList | DynamicList;
  user?: Person;
}

interface MapStateProps {
  data: any;
  listId: string | undefined;
  inProgress: boolean;
}

export type Props = ComponentProps & MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { data, fetchList, listId, forceNumberOfItems, json, inProgress } = props;

  const list = data?.list?.list;
  const [wasOnScreen, setWasOnScreen] = React.useState(false);
  const [items, setItems] = React.useState(null);
  const [retries, setRetries] = React.useState(0);
  const thisRef = React.useRef(null);
  const isOnScreen = useOnScreen(thisRef);

  React.useEffect(() => {
    const variables = { listId, count: 5 };
    if (!list && retries < 3 && !inProgress) {
      setRetries(retries + 1);
      fetchList({ variables });
    }
  }, [data, listId, list, fetchList, isOnScreen, retries, setRetries, inProgress]);

  React.useEffect(() => {
    if (isOnScreen && !wasOnScreen) {
      setWasOnScreen(true);
    }
  }, [isOnScreen, setWasOnScreen, wasOnScreen]);

  React.useEffect(() => {
    if (list?.items?.edges && items === null) {
      const day = parseInt(Router.getParameterByName("day"));
      const currentDay = getPTDate().getDate();
      const seed = day || currentDay;
      const [first, ...rest] = rotate([...list?.items?.edges], seed);
      const generator = PseudoRandom((seed + 1) * 12356);
      const randomRest = randomize(rest, () => generator());
      const _items = [first, ...randomRest];
      setItems(_items);
    }
  }, [list, setItems, items]);


  // if (id === undefined || id === null) {
  //   return <div className="alert alert-danger about-danger">Error Loading Mini Hero!</div>;
  // }

  const edge = items && items[0];
  const item = edge?.listItem?.item;
  if (!item || !list) {
    return null;
  }
  const previews: ItemPreviews = getPreviews(item, list);

  return (
    <div ref={thisRef} id="mini-heri-container">
      <MiniHeroPanel item={item} list={list} previews={previews} json={json} />
    </div>
  );
};

//const getListId = (props: ComponentProps) => props.list?.id || props.fixedList?.id || props.json?.sourceId;

const mapState = (state: AppState, props: ComponentProps) => {
  // const id: string = getListId(props);
  const listId = props && props["fixed-list"] && props["fixed-list"].id; //RadivisionInterviewsShowId; // || id;
  const data = state.cache.store[listId];
  const inProgress = state.cache.inProgress[listId];
  return {
    listId,
    data,
    inProgress,
  };
};

const mapDispatch = {
  fetchList: Actions.fetchList,
};

export const MiniHero = connect(mapState, mapDispatch)(Component);
